import { Stack } from '@servicetitan/design-system';
import { NavigationItem } from './navigation-item';
import { AppRouteProps, AppRoutes } from '../../utils/app-routes';

export const Navigation = () => (
    <Stack spacing={4}>
        <NavigationItem
            iconName="people"
            name="Accounts Management"
            to={AppRouteProps[AppRoutes.AccountsManagement].path}
        />
        <NavigationItem
            iconName="bullhorn"
            name="Marketing Pro"
            to={AppRouteProps[AppRoutes.Marketing].path}
        />
        <NavigationItem
            iconName="fleet-pro"
            name="Fleet Pro"
            to={AppRouteProps[AppRoutes.Fleet].path}
        />
    </Stack>
);
